"use client";
import React from "react";
import Image from "next/image";
import Images from "@/app/assets/assets";

type ImageKey = keyof typeof Images;

export type StageSlide = {
  year: number;
  imageKey: ImageKey;
  rotationClass: 'rotate-6' | '-rotate-6';
  alt: string;
};

type StageProps = {
  slides: StageSlide[];
};

export default function Stage({ slides }: StageProps) {
  const trackStyle = undefined; // GSAP controls #slidesTrack transform
  const baseAspectRatio = "550 / 350";
  return (
    <div className="absolute inset-0">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[150px]">
        <div className="relative">
          {/* Year track: uses current gap (420px) */}
          <div
            id="yearTrack"
            className="year-track flex flex-col items-center gap-[420px] z-0 will-change-transform"
            style={trackStyle}
          >
            {slides?.map((s, idx) => (
              <div
                key={`year-${s.year}`}
                className="relative w-[550px] h-[350px] flex items-center justify-center"
                data-idx={idx}
              >
                <div className="text-white/5 font-black 2xl:text-[400px] text-[30vw] leading-none select-none pointer-events-none">
                  {s.year}
                </div>
              </div>
            ))}
          </div>

          {/* Image track: larger gap (1.5x -> 630px) and above year */}
          <div
            id="imageTrack"
            className="image-track absolute inset-0 flex flex-col items-center gap-[630px] z-10 will-change-transform"
            style={trackStyle}
          >
            {slides?.map((s, idx) => (
              <div
                key={`img-${s.year}`}
                className="relative 2xl:w-[550px] w-[80vw] slide"
                data-idx={idx}
              >
                <div
                  className={`parallax-img relative w-full 2xl:w-[550px] 2xl:shadow-[0_30px_120px_-20px_rgba(0,0,0,0.55)] ${s.rotationClass}`}
                  style={{ aspectRatio: baseAspectRatio }}
                >
                  <div className="parallax-inner relative will-change-transform h-full w-full overflow-hidden">
                    <Image
                      src={Images[s.imageKey]}
                      alt={s.alt}
                      fill
                      className="object-cover"
                      sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                      priority={idx === 0}
                      fetchPriority={idx === 0 ? "high" : "auto"}
                      loading={idx === 0 ? "eager" : "lazy"}
                    />
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
